/**
 * Thrown by control publishes when MQTT is not connected or there is no unit
 * context, so callers surface a real failure (toast + revert optimistic state)
 * instead of the old silent no-op that made dead commands look successful.
 */
export class MqttUnavailableError extends Error {
  constructor(public readonly reason: 'disconnected' | 'no_unit' = 'disconnected') {
    super(`MQTT unavailable: ${reason}`);
    this.name = 'MqttUnavailableError';
  }
}
